<script lang="ts" setup>
</script>

<template>
  <div class="rounded-3xl bg-white px-4 py-6 lg:p-6">
    <slot />
  </div>
</template>
